import { render, staticRenderFns } from "./create.vue?vue&type=template&id=3faa90ef&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3faa90ef')) {
      api.createRecord('3faa90ef', component.options)
    } else {
      api.reload('3faa90ef', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=3faa90ef&", function () {
      api.rerender('3faa90ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/apps/create.vue"
export default component.exports